import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LebanonFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15405'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15405)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#F03340'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#F03340'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.24343 8.67446C9.3972 8.52376 9.3972 8.27616 9.24343 8.12546L9.1872 8.07036C9.10024 7.98513 8.9754 7.95092 8.85714 7.97989L8.57057 8.0501C8.25919 8.12639 8.06891 7.7191 8.32723 7.52924L8.57064 7.35034C8.72165 7.23934 8.64314 6.99996 8.45572 6.99996C8.25013 6.99996 8.18572 6.72215 8.37035 6.63169L8.77195 6.4349C8.95658 6.34443 8.89217 6.06663 8.68658 6.06663C8.49916 6.06663 8.42065 5.82725 8.57166 5.71625L9.62975 4.93856C9.84987 4.77677 10.1496 4.77677 10.3697 4.93856L11.4278 5.71625C11.5788 5.82725 11.5003 6.06663 11.3129 6.06663C11.1073 6.06663 11.0429 6.34443 11.2275 6.4349L11.6291 6.63169C11.8137 6.72215 11.7493 6.99996 11.5437 6.99996C11.3563 6.99996 11.2778 7.23934 11.4288 7.35034L11.6722 7.52924C11.9305 7.7191 11.7403 8.12639 11.4289 8.0501L11.1423 7.97989C11.024 7.95092 10.8992 7.98513 10.8122 8.07036L10.756 8.12546C10.6022 8.27616 10.6022 8.52376 10.756 8.67446C11.0019 8.91543 10.8313 9.33329 10.487 9.33329H9.51244C9.16816 9.33329 8.99754 8.91543 9.24343 8.67446Z'
					fill='#1FC065'
				/>
			</g>
		</svg>
	);
};

export default LebanonFlagIcon;
